import { render, staticRenderFns } from "./ClientInfoData.vue?vue&type=template&id=2b5f6a1b&scoped=true"
import script from "./ClientInfoData.vue?vue&type=script&lang=js"
export * from "./ClientInfoData.vue?vue&type=script&lang=js"
import style0 from "./ClientInfoData.vue?vue&type=style&index=0&id=2b5f6a1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f6a1b",
  null
  
)

export default component.exports